import React, { useEffect, useState } from "react";

type Theme = "light" | "dark";

function getInitialTheme(): Theme {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem("g8-theme") as Theme | null;
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("g8-theme", theme);
  }, [theme]);

  return (
    <button
      onClick={() => setTheme((t) => (t === "light" ? "dark" : "light"))}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      style={{
        position: "fixed",
        bottom: "1.25rem",
        right: "1.25rem",
        zIndex: 50,
        width: "2.5rem",
        height: "2.5rem",
        borderRadius: "50%",
        border: "1px solid color-mix(in srgb, var(--color-muted, #6b7280) 30%, transparent)",
        background: "var(--color-background, #fff)",
        color: "var(--color-foreground, #111)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.1rem",
        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
        transition: "opacity 0.15s",
      }}
    >
      {theme === "light" ? "🌙" : "☀️"}
    </button>
  );
}
